import type { ReactNode } from "react";

type AuthCardProps = {
  title: string;
  subtitle: string;
  children: ReactNode;
};

export default function AuthCard({ title, subtitle, children }: AuthCardProps) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-lg border border-border bg-card p-10 shadow-sm">
        <div className="text-center">
          <div className="font-display text-3xl text-primary">FormFlow</div>
          <div className="mt-6 font-display text-2xl font-semibold text-foreground">
            {title}
          </div>
          <div className="mt-2 mb-8 text-sm text-muted-foreground">
            {subtitle}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}

